// @ts-nocheck
import { CHANGE_REQUEST_UPLOAD_FILE_ERROR, CHANGE_REQUEST_UPLOAD_FILE_LOADING, CHANGE_REQUEST_UPLOAD_FILE_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const ChangeRequestUploadFileReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_REQUEST_UPLOAD_FILE_LOADING:
            return Object.assign({}, state, { loading: true })
        case CHANGE_REQUEST_UPLOAD_FILE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CHANGE_REQUEST_UPLOAD_FILE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

